<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'primevue/button';

import { useVisibleCalculationItems } from '@/composables/useVisibleCalculationItems';
import { useEstimatedSegments } from '@/composables/useEstimatedSegments';

const { hiddenFilter, toggleHiddenFilter } = useVisibleCalculationItems();
const route = useRoute();

const allRulesFilters = computed(() => ({
  hidden: 'all' as const,
  ruleTypes: ['calculation'],
  includeChildRules: false,
  includeSegmentRules: true,
  includeGroupRules: true,
}));

const { segmentRules: allRules } = useEstimatedSegments(allRulesFilters);

function getHiddenIcon() {
  return hiddenFilter.value === 'unhidden-only' ? 'pi-eye-slash' : 'pi-eye';
}

function getHiddenCount() {
  if (!allRules.value) return 0;

  const segmentIdParam = route.params.segmentId;
  const groupIdParam = route.params.groupId;
  const hasSegmentScope = segmentIdParam !== undefined && segmentIdParam !== '';

  const segmentsInScope = hasSegmentScope
    ? allRules.value.filter(
        (segment) => segment.id === Number(segmentIdParam) && segment.rules.length
      )
    : allRules.value;

  const hasGroupScope = groupIdParam !== undefined && groupIdParam !== '';

  let count = 0;
  segmentsInScope.forEach((segment) => {
    const groupsInScope = hasGroupScope
      ? segment.groups.filter(
          (group) => group.id === Number(groupIdParam) && group.rules.length
        )
      : segment.groups;

    groupsInScope.forEach((group) => {
      count += group.rules.filter((rule) => (rule as any).is_hidden).length;
    });

    count += segment.rules.filter((rule) => (rule as any).is_hidden).length;
  });

  return count;
}
</script>

<template>
  <Button severity="secondary" text icon @click="toggleHiddenFilter" size="small">
    <i :class="`pi ${getHiddenIcon()}`"></i>
    <span v-if="hiddenFilter === 'unhidden-only'" class="ml-1">
      ({{ getHiddenCount() }})
    </span>
  </Button>
</template>
